import { useRegionParametersQuery } from '@innovamat/glow-api-client';
import { stages } from '@innovamat/radiance-utils';
import { useLocation } from 'react-router-dom';

import { useCurrentNavigationValues } from '../../navigation';
import { useUser } from '../../user-management';

type RegionParameters = {
  defaultRegion?: string;
  defaultCourseOrder?: number;
};

export function useRegionParameters({
  defaultRegion,
  defaultCourseOrder,
}: RegionParameters) {
  const location = useLocation();
  const { user } = useUser();
  const { courseOrder } = useCurrentNavigationValues();

  // Obtener el parámetro 'region' de la URL para el caso de recursos públicos
  const urlSearchParams = new URLSearchParams(location.search);
  const urlRegion = urlSearchParams.get('region');
  if (urlRegion) {
    localStorage.setItem('region', urlRegion);
  }

  const regionCode =
    defaultRegion || urlRegion || user?.region?.replace('-LIT', '');

  const order = defaultCourseOrder || courseOrder;
  const stage = stages.isSecundaria(order) ? 'secondary' : 'primary';

  const query = useRegionParametersQuery(
    { regionCode: regionCode!, stage: stage! },
    { enabled: Boolean(regionCode && stage), staleTime: Infinity }
  );

  return {
    ...query,
    regionParameters: {
      ...query.data?.regionParameters,
      dataOrigin: 'front-web-ga',
    },
  };
}
